import { render, staticRenderFns } from "./hot-lectures.vue?vue&type=template&id=354c975c&scoped=true&"
import script from "./hot-lectures.vue?vue&type=script&lang=js&"
export * from "./hot-lectures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c975c",
  null
  
)

export default component.exports